module.exports = __webpack_public_path__ + "static/media/sell_send_money_7.7fca05ac.jpg";